import axios from 'axios'
import { Notification, Message } from 'element-ui'
import { getAccessToken, getLocationID, getMerchanIDCurrent, getUserId } from './auth'
import { statusCodeResponse } from './mapping'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_GATEWAY_API_URL, // url = base url + request url
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 20000, // request timeout
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'authorization': 'Bearer ' + getAccessToken(),
    'np-app-id': process.env.VUE_APP_ID,
    'np-location-id': getLocationID(),
    'np-merchant-id': getMerchanIDCurrent(),
    'np-user-id': getUserId()
  }
})

// request interceptor
let configReq = {}
service.interceptors.request.use(
  config => {
    // do something before request is sent
    configReq = config
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    if (statusCodeResponse(response.data.code)) {
      Notification({
        title: 'Thông báo',
        type: 'warning',
        message: statusCodeResponse(response.data.code)
      })
    }
    return response.data
  },
  error => {
    console.log('err' + error) // for debug
    Message.error('Có lỗi xảy ra. Hãy thử lại sau')
    return error
  }
)

export default service